<template>
    <div class="pro-edit">
        <a-form>
            <a-form-item
                    label="商品主圖"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                    required
            >
                <a-upload
                        list-type="picture-card"
                        :file-list="fileList"
                        @preview="handlePreview"
                        @change="handleChange"
                        :disabled="upLoading"
                        :customRequest="upPic"
                >
                    <div v-if="fileList.length < 5">
                        <a-icon :type="upLoading?'loading':'plus'"/>
                        <div class="ant-upload-text">上傳主圖 推荐342*342</div>
                    </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                    <img alt="example" style="width: 100%" :src="previewImage"/>
                </a-modal>
            </a-form-item>
            <a-form-item
                    label="商品標題"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-input style="width:450px;" :maxLength="30" allowClear placeholder="請輸入商品標題"
                         v-model="form.productTitle"></a-input>
                <span class="num-other">{{form.productTitle?form.productTitle.length:0}}/30</span>
            </a-form-item>
            <a-form-item
                    label="商品推薦主圖"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                    required
            >
                <a-upload
                        name="avatar"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        :disabled="upLoading"
                        :customRequest="upbigPic"
                >
                    <img style="max-width:200px;" v-if="imageUrl" :src="imageUrl" alt="avatar"/>
                    <div v-else>
                        <a-icon :type="upLoading ? 'loading' : 'plus'"/>
                        <div class="ant-upload-text">上傳推薦主圖</div>
                    </div>
                </a-upload>
                <p style="color:red;">推荐大小：750*404</p>
            </a-form-item>
            <a-form-item
                    label="商品簡介"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-input style="width:450px;" allowClear placeholder="請輸入商品簡介"
                         v-model="form.productIntroduce"></a-input>
                <span class="num-other">{{form.productIntroduce?form.productIntroduce.length:0}}/30</span>
            </a-form-item>
            <a-form-item
                    label="是否有不同商品属性"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-radio-group v-model="hasSku">
                    <a-radio :value="1">是</a-radio>
                    <a-radio :value="0">否</a-radio>
                </a-radio-group>
                <br/>
            </a-form-item>
            <a-form-item
                    v-if="hasSku === 0"
                    label="商品庫存"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-input min="0" style="width:110px;" type="number" allowClear placeholder="庫存"
                         v-model="form.inventoryNum"></a-input>
            </a-form-item>
            <a-form-item
                    v-if="hasSku === 0"
                    label="商品價格"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-input min="0" style="width:110px;" type="number" allowClear placeholder="價格"
                         v-model="form.productPrice"></a-input>
            </a-form-item>
            <a-form-item
                    v-if="hasSku === 1"
                    label="商品属性"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 16 }"
                    required
            >
                <div class="sku-box">
                    <a-button @click="addItem">添加一行</a-button>
                    <div class="sku-list">
                        <div class="sku-item" v-for="(item,index) in skuList">
                            <a-input min="0" type="text" style="width:140px;margin-right:10px;" addon-before="属性名"
                                     v-model="item.name"/>
                            <a-input min="0" type="number" style="width:140px;margin-right:10px;" addon-before="价格"
                                     v-model="item.price"/>
                            <a-input min="0" type="number" style="width:140px;margin-right:10px;" addon-before="库存"
                                     v-model="item.num"/>
                            <a-button type="link" @click="delSku(index)">删除该条</a-button>
                        </div>
                    </div>
                </div>
            </a-form-item>
            <a-form-item
                    label="商品分類"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-select v-model="form.categoryId" style="width: 160px">
                    <a-select-option :key="item.id" v-for="item in categoryList" :value="item.id">
                        {{item.categoryName}}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item
                    label="商品重量"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-input placeholder="重量" type="number" v-model="form.productWeight" style="width:100px;"></a-input>
                kg
            </a-form-item>
            <a-form-item
                    label="郵費模板"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-select v-model="form.templateId" style="width: 160px" @change="freightChange">
                    <a-select-option :key="item.id" v-for="item in freightList" :value="item.id">{{item.templateName}}
                    </a-select-option>
                </a-select>
                <ul class="freight-text" v-if="freightObj && !freightObj.isFreight">
                    <li v-for="(sub,sIndex) in freightObj.templateDetail" v-if="!sub.isFreight">
                        <p class="top">{{sub.areaList}}</p>
                        <p class="bottom">{{sub.freight}}</p>
                    </li>
                    <li v-else>
                        <p class="top">{{sub.areaList}}</p>
                        <p class="bottom">包郵</p>
                    </li>
                </ul>
                <p class="freight-text-p" v-if="freightObj && freightObj.isFreight">郵費詳情：所有地區包郵</p>
            </a-form-item>
            <a-form-item
                    label="是否加入推荐"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-switch v-model="isCommend"/>
            </a-form-item>
            <a-form-item
                    label="权限控制"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <a-radio-group name="radioGroup" v-model="form.limit.userType">
                    <a-radio :value="1">游客</a-radio>
                    <a-radio :value="2">注册会员</a-radio>
                    <a-radio :value="3">会员</a-radio>
                </a-radio-group>
                <br v-if="form.limit.userType === 3">
                <a-checkbox-group v-if="form.limit.userType === 3" name="radioGroup1" v-model="form.limit.vipType">
                    <a-checkbox :value="item.id" v-for="(item,index) in vipList" :key="index">{{item.vipDesc}}
                    </a-checkbox>
                </a-checkbox-group>
            </a-form-item>
            <a-form-item
                    label="商品詳情"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 14 }"
                    required
            >
                <div id="toolbar">
                    <!-- Add font size dropdown -->
                    <select class="ql-size">
                        <option value="small">字号(小)</option>
                        <!-- Note a missing, thus falsy value, is used to reset to default -->
                        <option selected>字号(中)</option>
                        <option value="large">字号(大)</option>
                        <option value="huge">字号(巨大)</option>
                    </select>
                    <!-- Add a bold button -->
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                    <button class="ql-strike"></button>
                    <button class="ql-script" value="sub"></button>
                    <button class="ql-script" value="super"></button>
                    <button class="ql-indent" value="+1">缩进</button>
                    <button class="ql-indent" value="-1"></button>
                    <!-- Add subscript and superscript buttons -->
                    <select class="ql-color"></select>
                    <select class="ql-background"></select>
                    <button class="ql-blockquote"></button>
                    <select class="ql-header">
                        <option value="1">标题1</option>
                        <option value="2">标题2</option>
                        <option value="3">标题3</option>
                        <option value="4">标题4</option>
                        <option value="5">标题5</option>
                    </select>
                    <select class="ql-align"></select>
                    <button class="ql-link"></button>
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <a-upload
                            :showUploadList="false"
                            :withCredentials="true"
                            multiple
                            accept="image/*"
                            list-type="picture"
                            :customRequest="upPicDetail">
                        <button class="ql-image">
                            <a-icon type="picture" style="font-size: 18px;"/>
                        </button>
                    </a-upload>
                </div>
                <quill-editor v-model="detail"
                              ref="myQuillEditor1"
                              :options="editorOption">
                </quill-editor>
                <a-button :loading="subLoading" @click="sub" type="primary"
                          style="width:300px;display:block;margin:30px auto;" size="large">提交
                </a-button>
            </a-form-item>
        </a-form>
    </div>
</template>
<script>
    import {quillEditor} from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    export default {
        data() {
            return {
                freightList: [],
                skuList: [
                    {name: undefined, price: undefined, num: undefined}
                ],
                hasSku: 1,
                isCommend: false,
                subLoading: false,
                upLoading: false,
                previewVisible: false,
                previewImage: '',
                fileList: [],
                form: {
                    bannerPicPath: undefined,
                    categoryId: undefined,
                    inventoryNum: undefined,
                    productDesc: undefined,
                    productIntroduce: undefined,
                    productPrice: undefined,
                    productTitle: undefined,
                    productWeight: undefined,
                    templateId: null,
                    limit: {
                        userType: 1,
                        vipType: []
                    }
                },
                categoryList: [],
                editorOption: {
                    modules: {
                        toolbar: '#toolbar'
                    },
                    placeholder: '請在此處編輯叢書詳情'
                },
                detail: undefined,
                imageUrl: undefined,
                freightObj: null,
                vipList: []
            }
        },
        components: {quillEditor},
        computed: {
            editor() {
                return this.$refs.myQuillEditor1.quill
            },
            submitDetail: function () {
                if (this.detail.split('my-ql').length > 1) {
                    return this.form.productDesc
                } else {
                    return '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd"><html><head><meta http-equiv="Content-Type" content="text/html;charset=UTF-8"><link rel="stylesheet" href="https://m.09dt.net/cdn/quill.bubble.css"><link rel="stylesheet" href="https://m.09dt.net/cdn/quill.core.css"><link rel="stylesheet" href="https://m.09dt.net/cdn/quill.snow.css"><style>*{font-size: 16px;}.my-ql{padding:0;}img{max-width:100%!important;}</style></head><body><div class="ql-editor my-ql">'
                        + this.detail +
                        '</div></body></html>'
                }
            },
        },
        watch: {
            'form.limit.userType': function (val) {
                if (val !== 3) {
                    this.form.limit.vipType.splice(0, this.form.limit.vipType.length)
                }
            }
        },
        methods: {
            getVip() {
                let self = this;
                self.$http({
                    method: 'post',
                    url: '/manager/vip/list',
                }).then(function (res) {
                    self.vipList = res.data;
                }).catch(err => {
                    self.$Message.error(JSON.stringify(err))
                })
            },
            freightChange(id) {
                let obj = this.freightList.find(item => {
                    return item.id === id
                })
                this.freightObj = obj ? obj : null
            },
            getFreight() {
                let self = this;
                self.tableLoading = true;
                self.$http({
                    method: 'post',
                    url: '/manager/product/freight/list',
                    data: {
                        pageIndex: 1,
                        pageSize: 100
                    }
                }).then(res => {
                    res.data.forEach(item => {
                        if (item.templateDetail) {
                            item.templateDetail.forEach(sub => {
                                let arr = []
                                sub.areas.forEach(s => {
                                    arr.push(s.provinceName)
                                })
                                sub.areaList = arr.join(',');
                                if (!sub.isFreight) {
                                    sub.freight = `基礎郵費：每${(sub.basicUnit / 1000).toFixed(2)}kg,${(sub.basicFee / 100).toFixed(2)}元；後續郵費：每增加${(sub.addUnit / 1000).toFixed(2)}kg,增加${(sub.addFee / 100).toFixed(2)}元`;
                                } else {
                                    sub.freight = '包郵'
                                }
                            })
                        }
                    })
                    self.freightList = res.data ? res.data : []
                }).catch(err => {
                })
            },
            delSku(index) {
                if (this.skuList.length > 1) {
                    this.skuList.splice(index, 1)
                } else {
                    this.$Message.warning('选择多属性，至少要存在一条属性数据')
                }
            },
            addItem() {
                this.skuList.push({name: undefined, price: undefined, num: undefined})
            },
            sub() {
                let self = this;
                if (!this.validate()) {
                    return false;
                }
                this.form.productDesc = this.submitDetail;
                let arr = [];
                this.fileList.forEach(item => {
                    arr.push(item.url)
                })
                if (this.hasSku === 0) {
                    this.form.productPrice = this.form.productPrice * 100
                    this.form.inventoryNum = this.form.inventoryNum * 1;
                } else {
                    delete this.form.productPrice;
                    delete this.form.inventoryNum;
                    let skuObj = []
                    this.skuList.forEach(item => {
                        skuObj.push({
                            inventoryNum: item.num,
                            productPrice: item.price * 100,
                            skuDesc: item.name
                        })
                    })
                    this.form.skus = skuObj;
                }
                this.form.productImages = arr;
                this.form.productState = 20;
                this.form.recommendState = this.isCommend ? 1 : -1;
                this.form.productWeight = this.form.productWeight * 1000
                this.subLoading = true;
                let url;
                if (this.$route.query.id) {
                    this.form.id = this.$route.query.id;
                    url = '/manager/product/update'
                } else {
                    delete this.form.id;
                    url = '/manager/product/add'
                }
                let data=JSON.parse(JSON.stringify(this.form))
                if(data.limit.userType !==3){
                    delete data.limit.vipType;
                }
                //、productState -1 刪除10 下架 20 上架
                this.$http.post(url, data).then(res => {
                    self.$Message.success('操作成功');
                    self.subLoading = false;
                    self.$router.replace({name: 'proList'})
                }).catch(err => {
                    self.form.productPrice = self.form.productPrice / 100
                    self.form.productWeight = self.form.productWeight / 1000
                    self.subLoading = false;
                })
            },
            validate() {
                if (!this.fileList.length) {
                    this.$Message.warning('請上傳商品主圖');
                    return false;
                }
                if (this.form.productTitle === '' || !this.form.productTitle) {
                    this.$Message.warning('請輸入商品標題');
                    return false;
                }
                if (!this.form.bannerPicPath || this.form.bannerPicPath === '') {
                    this.$Message.warning('請上傳推薦主圖');
                    return false;
                }
                if (this.form.productIntroduce === '' || !this.form.productIntroduce) {
                    this.$Message.warning('請輸入商品簡介');
                    return false;
                }
                if (this.hasSku === 0) {
                    if (this.form.inventoryNum === '' || !this.form.inventoryNum) {
                        this.$Message.warning('請輸入商品庫存');
                        return false;
                    }
                    if (this.form.productPrice === '' || !this.form.productPrice) {
                        this.$Message.warning('請輸入商品價格');
                        return false;
                    }
                } else {
                    let skuFlag = true;
                    this.skuList.forEach(item => {
                        if (
                            (!item.name || item.name === '')
                            || (!item.price || item.price === '' || item.price <= 0)
                            || (!item.num || item.num === '' || item.num <= 0)
                        ) {
                            skuFlag = false;
                        }
                    })
                    if (!skuFlag) {
                        this.$Message.warning('属性名称或者属性价格或者属性库存不能为空或者0');
                        return false;
                    }
                }
                if (this.categoryList.length > 0) {
                    if (this.form.categoryId === '' || !this.form.categoryId) {
                        this.$Message.warning('請選擇商品分類');
                        return false;
                    }
                } else {
                    this.$Message.warning('請先添加商品分類');
                    return false;
                }
                if (this.form.productWeight === '' || !this.form.productWeight) {
                    this.$Message.warning('請輸入商品重量');
                    return false;
                }
                if (!this.form.templateId) {
                    this.$Message.warning('請選擇郵費模板');
                    return false;
                }
                if (this.form.userType === 3 && !this.form.vipType.length) {
                    this.$Message.warning('请选择会员类型');
                    return false;
                }
                if (this.editor.getContents().ops.length === 1 && this.editor.getContents().ops[0].insert === '\n') {
                    this.$Message.warning('請輸入商品詳情')
                    return false;
                }
                return true;
            },
            upbigPic(file) {
                this.upLoading = true;
                let self = this;
                let param = new FormData()
                param.append('files', file.file)
                let config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };
                this.$http.post('/manager/media/upload/pic', param, config)
                    .then(response => {
                        self.upLoading = false;
                        self.$Message.success('上傳成功')
                        self.form.bannerPicPath = response.data.mediaInfo[0].path;
                        self.imageUrl = response.data.mediaInfo[0].path;
                    }).catch(err => {
                    console.log(err)
                    self.$Message.warning('上傳失敗');
                    self.upLoading = false;
                })
            },
            upPic(file, other) {
                this.upLoading = true;
                let self = this;
                let param = new FormData()
                param.append('files', file.file)
                let config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };
                this.$http.post('/manager/media/upload/pic', param, config)
                    .then(response => {
                        self.upLoading = false;
                        self.$Message.success('上傳成功')
                        self.fileList.forEach(item => {
                            if (item.uid === file.file.uid) {
                                item.url = response.data.mediaInfo[0].path;
                                item.id = response.data.mediaInfo[0].id;
                                item.status = 'done';
                            }
                        })
                    }).catch(err => {
                    self.$Message.warning('上傳失敗');
                    self.upLoading = false;
                })
            },
            handleCancel() {
                this.previewVisible = false;
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            handleChange({fileList}) {
                console.log(fileList)
                this.fileList = fileList;
            },
            getList() {
                let self = this;
                self.$http({
                    method: 'get',
                    url: '/manager/product/category/list',
                }).then(res => {
                    self.categoryList = res.data ? res.data : []
                })
            },
            upPicDetail(file) {
                let self = this;
                this.$load.show();
                let param = new FormData()
                param.append('files', file.file)
                let config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };
                this.$http.post('/manager/media/upload/pic', param, config)
                    .then(response => {
                        self.editor.insertEmbed(self.editor.selection.savedRange.index, 'image', response.data.mediaInfo[0].path)
                        self.$load.hide();
                    })
            },
            getDetail() {
                let self = this;
                self.$http({
                    method: 'get',
                    url: '/manager/product/detail',
                    params: {id: self.$route.query.id},
                }).then(res => {
                    self.setData(res.data)
                })
            },
            setData(data) {
                this.form.bannerPicPath = data.bannerPicPath
                this.form.categoryId = data.categoryId
                this.form.productDesc = data.productDesc
                this.form.productIntroduce = data.productIntroduce
                this.form.productTitle = data.productTitle
                this.form.productWeight = data.productWeight ? data.productWeight / 1000 : undefined;
                this.form.templateId = data.templateId ? data.templateId : null
                if (!data.skus.length) {
                    this.form.productPrice = data.productPrice / 100
                    this.form.inventoryNum = data.inventoryNum;
                    this.hasSku = 0;
                } else {
                    let skuObj = []
                    data.skus.forEach(item => {
                        skuObj.push({name: item.skuDesc, price: item.productPrice / 100, num: item.inventoryNum})
                    })
                    this.skuList = skuObj;
                    this.hasSku = 1;
                }
                this.imageUrl = data.bannerPicPath;
                this.isCommend = data.recommendState === 1 ? true : false
                this.form.limit.userType = data.limit.userType;
                if (!this.form.limit.vipType) {
                    this.form.limit.vipType = []
                } else {
                    this.form.limit.vipType = data.limit.vipType;
                }
                let arr = []
                data.productImages.forEach((item, index) => {
                    arr.push({
                        uid: '-' + (index + 1),
                        name: 'image.png',
                        status: 'done',
                        url: item,
                    })
                })
                this.detail = data.productDesc;
                this.fileList = arr;
            }
        },
        created() {
            this.$emit('breadcrumbChange', ['商品管理', '編輯商品'])
            this.getList();
            this.getFreight();
            this.getVip();
            if (this.$route.query.id) {
                this.getDetail();
            }
        },
        mounted() {
            this.$nextTick(function () {
                let toolBar = this.editor.getModule('toolbar')
                toolBar.addHandler('image', function (value) {
                    this.quill.format('image', false)
                })
            })
        }
    }
</script>
<style lang="less">
    .pro-edit {
        .freight-text-p {
            line-height: 14px;
            font-size: 12px;
            color: #ff3657;
            margin-top: 20px;
        }

        .freight-text {
            padding: 0;

            p {
                line-height: 14px;
                font-size: 12px;
                color: #ff3657;
            }
        }

        .ant-upload-list-picture-card .ant-upload-list-item-info:before {
            left: 0;
        }

        .ant-form-item-control {
            text-align: left;
        }

        .num-other {
            color: #888;
            margin-left: 10px;
        }

        .ql-toolbar.ql-snow {
            border-bottom: none;
            padding-top: 14px;
            padding-bottom: 0;
        }

        .ql-snow .ql-editor img {
            display: inline-block;
        }

        .ql-snow .ql-picker.ql-size, .ql-snow .ql-picker.ql-header {
            border: 1px solid #f1f1f1;
            border-radius: 4px;
        }

        .ql-snow .ql-color-picker .ql-picker-label svg, .ql-snow .ql-icon-picker .ql-picker-label svg {
            right: 4px;
            top: -6px;
            position: relative;
        }

        .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
            content: attr(data-label);
            position: relative;
            top: -8px;
        }

        .quill-editor {
            height: 400px;
        }
    }
</style>